import * as uiHelpers from "../../app/admin/baskets/BasketsUIHelpers";

export const paginationOptions = (data) => {
    return {
        custom: true,
        totalSize: data.total,
        sizePerPageList: uiHelpers.sizePerPageList,
        sizePerPage: data.per_page,
        page: 1,
    }

};